import { FORM_ERROR } from 'final-form';
import _ from 'lodash';
import { VALIDATION_ERROR } from '../define/response';
import { notifyError } from './action';
export const getUploadFileErrorText = (error) => {
    let errorText = '';
    if (error === 'encrypt_pdf') {
        errorText = 'パスワード付きのPDFファイルです。';
    }
    else if (error === 'encrypt_pptx') {
        errorText = 'パスワード付きのPPTXファイルです。';
    }
    else if (error === 'file_type_error') {
        errorText = 'アップロードしたファイルが指定の形式ではありません';
    }
    return errorText;
};
/**
 * エラーオブジェクトからエラーを取得
 * @param error
 * @returns {{code, message, messages, ...}}
 */
export const getErrorFromErrorObject = (error) => {
    const { response } = error;
    const { data: responseData } = response || {};
    return responseData || {};
};
/**
 * エラー内容に応じて、SubmissionErrorで使用するオブジェクトを返す
 * @param error
 * @param invalidWhen
 * @returns {{}}
 */
export const createValidateErrorData = (error, invalidWhen) => {
    const { code: errorCode, message: errorMessage, messages, } = getErrorFromErrorObject(error);
    const errorMessages = {};
    let bodyMessage = '';
    // バリデーションの設定
    const messageKeys = Object.keys(messages || {});
    messageKeys.forEach((key) => {
        // eslint-disable-next-line prefer-destructuring
        errorMessages[key] = messages[key][0];
    });
    if (invalidWhen && errorCode && invalidWhen[errorCode]) {
        const checkValue = invalidWhen[errorCode];
        if (_.isString(checkValue)) {
            bodyMessage = invalidWhen[errorCode];
        }
        else if (_.isObject(checkValue) && checkValue.key && checkValue.message) {
            errorMessages[checkValue.key] = checkValue.message;
        }
    }
    else if (errorMessage) {
        // eslint-disable-next-line
        bodyMessage = errorMessage;
    }
    if (bodyMessage) {
        // eslint-disable-next-line
        errorMessages._error = bodyMessage;
    }
    return errorMessages;
};
/**
 * エラー内容に応じて、FinalFormのonSubmitで返すエラー用オブジェクトを返す
 * @param error
 * @returns {{}}
 */
export const createFinalFormValidateErrors = (error) => {
    const { code, data: { messages }, } = getErrorFromErrorObject(error);
    if (code !== VALIDATION_ERROR) {
        notifyError();
        return {
            [FORM_ERROR]: 'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。',
        };
    }
    const errorMessages = {};
    const messageKeys = Object.keys(messages || {});
    messageKeys.forEach((key) => {
        // eslint-disable-next-line prefer-destructuring
        errorMessages[key] = messages[key][0];
    });
    return errorMessages;
};
/**
 * createValidateErrorDataで取得した値にエラーが存在するかどうか
 * @param errorMessages
 */
export const hasReduxFormError = (errorMessages) => Object.keys(errorMessages).length > 0;
